function LandingPageWrapper({
    children,
    paddingFromTop = true,
    sectionSpacing = true,
}) {
    const topPadding = paddingFromTop ? 'md:mt-20 mt-10' : ''
    const sectionSpacingClass = sectionSpacing ? 'space-y-10 md:space-y-20' : ''

    return (
        <div
            className={`${sectionSpacingClass} ${topPadding} relative xl:px-0`}>
            {children}
        </div>
    )
}

export default LandingPageWrapper
